export const actionsWithDescription = [
  {
    id: 'edit-image',
    title: 'Edit Image with AI',
    description: 'Edit your image with AI by describing the changes you want.',
    users: '2 credits per image',
    image: '/img/tools/FindReplaceGraphic.jpg',
  },
  // halloween
  // {
  //   id: 'halloween',
  //   title: 'Halloween',
  //   description: 'Create 15 Halloween-themed photos from uploaded images',
  //   users: '30 credits',
  //   image:
  //     'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/11d7a5d8-ef2f-4f49-a071-d32ea9b72fc8.png',
  //   isNew: true,
  // },
  {
    id: 'hyper-realistic-photos',
    title: 'Hyper Realistic Photos',
    description:
      'Transform your photos into ultra-realistic, lifelike images with stunning detail and natural lighting',
    users: '2 credits per image',
    image:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/f5d5470c-2e5c-477b-934c-fe4264cefa44.png',
    isNew: true,
  },
  {
    id: 'character-reference',
    title: 'Character Reference',
    description: 'Create images of the same character in different situations.',
    users: '3 credits per image',
    image: '/img/tools/character-reference.png',
    isNew: true,
  },
  {
    id: 'visualize-what-happens-next',
    title: 'Visualize What Happens Next',
    description:
      'Create a 3x3 grid showing story-driven scenes that flow like a narrative sequence from your image',
    users: '7 credits per image',
    image:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/5e2235e3-559b-47ef-be4c-492cea1ea82c.png',
    isNew: true,
  },
  // headshot
  // {
  //   id: 'headshot',
  //   title: 'Professional Headshot',
  //   description: 'Create a professional headshot with AI',
  //   users: '4 credits per image',
  //   image: '/img/tools/headshots.png',
  //   isNew: true,
  // },
  {
    id: 'stylization',
    title: 'Stylization',
    description: 'Create 8 different styles from a single photo.',
    users: '16 credits per image',
    image: '/img/tools/stylization.png',
  },
  // {
  //   id: 'realistic-photos',
  //   title: 'Realistic Photos',
  //   description: 'Create realistic photos from a single face image',
  //   users: '2 credits per image',
  // },
  {
    id: 'caricature',
    title: 'Caricature',
    description: 'Create fun caricature art from your photos',
    users: '2 credits per image',
    image: '/img/tools/caricature.png',
  },
  {
    id: 'ghiblify',
    title: 'Ghiblify',
    description:
      'Reimagine and transform your ordinary photos into enchanting Studio Ghibli style artwork',
    users: '2 credits per image',
    image: '/img/tools/japanese2.png',
    isNew: true,
  },
  {
    id: 'muppets',
    title: 'Muppets',
    description: 'Turn photos into muppets',
    users: '2 credits per image',
    image: '/img/tools/muppets.png',
    isNew: true,
  },

  // {
  //   id: 'consistent-character',
  //   title: 'Consistent Character',
  //   description:
  //     'Create images of the same human character in different poses.',
  //   users: '1 credit per image',
  // },
  // {
  //   id: 'style-reference',
  //   title: 'Style Reference',
  //   description: 'Influence the style or aesthetic of images you want to make.',
  //   users: '3 credits per image',
  // },
  // {
  //   id: 'style-reference-sd3',
  //   title: 'Style Reference SD3',
  //   description:
  //     'Influence the style or aesthetic of images you want to make. Powered by SD3.',
  //   users: '3 credits per image',
  // },
  // replace background
  {
    id: 'replace-background',
    title: 'Replace Background',
    description: 'Replace the background of your image with a new background.',
    users: '2 credits per image',
    image: '/img/tools/replace-background.png',
    isNew: true,
  },
  {
    id: 'remove-background',
    title: 'Remove Background',
    description: 'Remove background from your images automatically.',
    users: '1 credit per image',
    image: '/img/tools/remove-background.webp',
  },
  // {
  //   id: 'sketch-to-image',
  //   title: 'Sketch to Image',
  //   description: 'Convert your sketches to images.',
  //   users: '2 credits per image',
  // },
  // {
  //   id: 'find-and-replace',
  //   title: 'Find and Replace',
  //   description: 'Swap elements in your images with a text prompt.',
  //   users: '2 credits per image',
  // },
  // {
  //   id: 'structure-to-image',
  //   title: 'Structure to Image',
  //   description:
  //     'Take the shape and structure of an image and convert it to a new image based on your prompt.',
  //   users: '2 credits per image',
  // },
  // colorize
  {
    id: 'colorize',
    title: 'Colorize',
    description: 'Add color to your black and white images.',
    users: '2 credits per image',
    image: '/img/tools/restore-photo.png',
  },
  // // relight
  // {
  //   id: 'relight',
  //   title: 'Relight',
  //   description:
  //     'Magically relights your portrait photos using text descriptions.',
  //   users: '2 credits per image',
  // },
];
